import React from 'react';
import { storiesOf } from '@storybook/react';
import { action } from '@storybook/addon-actions';
import { TemplateAlerts } from './TemplateAlerts';

storiesOf('Manage Alerts/TemplateAlerts', module)
  .add('Loading', () => (
    <TemplateAlerts isLoading />
  ))
  .add('View without data', () => (
    <TemplateAlerts alerts={[]} />
  ))
  .add('View', () => (
    <TemplateAlerts
      alerts={sampleGetAlertsResponse.alerts}
      getAlerts={action('getTemplateAlerts')}
      updateAlert={action('updateTemplateAlert')}
    />
  ));

const sampleGetAlertsResponse = {
  alerts: [
    {
      id: 1,
      name: 'Business Bankruptcies',
      created: 1532043435,
      last_execute: 1540123200,
      type_label: 'Petitions',
      enabled: 1,
      notify_interval: '3600',
      notify_interval_options: [
        { value: -1, label: 'Save/Pause' },
        { value: 3600, label: 'Hourly' },
        { value: 86400, label: 'Daily' },
        { value: 604800, label: 'Weekly' },
      ],
      customize_access: true,
      isUpdating: { enabled: true },
    },
    {
      id: 2,
      name: 'Business Bankruptcies ­ Schedules',
      created: 1532043435,
      last_execute: 1544705100,
      type_label: 'Schedules',
      enabled: 0,
      notify_interval: '86400',
      notify_interval_options: [
        { value: -1, label: 'Save/Pause' },
        { value: 3600, label: 'Hourly' },
        { value: 86400, label: 'Daily' },
        { value: 604800, label: 'Weekly' },
      ],
      customize_access: true,
      isUpdating: { notify_interval: true },
    },
    {
      id: 3,
      name: 'Case Activity',
      created: 1532043435,
      last_execute: 1509573600,
      type_label: 'Case Activity',
      enabled: 1,
      notify_interval: '-1',
      notify_interval_options: [
        { value: -1, label: 'Save/Pause' },
        { value: 3600, label: 'Hourly' },
        { value: 86400, label: 'Daily' },
        { value: 604800, label: 'Weekly' },
      ],
      customize_access: true,
      resend: true,
    },
    {
      id: 4,
      name: 'New Cases Alert',
      created: 1532043435,
      last_execute: 1540123200,
      type_label: 'Cases',
      enabled: 1,
      notify_interval: '86400',
      notify_interval_options: [
        { value: -1, label: 'Save/Pause' },
        { value: 3600, label: 'Hourly' },
        { value: 86400, label: 'Daily' },
      ],
      customize_access: false,
    },
  ],
};



// WEBPACK FOOTER //
// ./src/components/searchAlerts/TemplateAlerts/TemplateAlerts.stories.jsx